import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

if (!customElements.get('testimonials-slider')) {
  class TestimonialsSlider extends HTMLElement {
    selectors = {
      imageSlider1: '[data-image-slider-1]',
      imageSlider2: '[data-image-slider-2]',
      contentSlider: '[data-content-slider]',
      prevArrow: '[data-arrow-prev]',
      nextArrow: '[data-arrow-next]',
    };

    imageSliderOptions = {
      slidesPerView: 1,
      spaceBetween: 10,
      simulateTouch: false,
      allowTouchMove: false
    }

    contentSliderOptions = {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 200,
      effect: 'coverflow',
      coverflowEffect: {
        stretch: 300,
        depth: 1,
        rotate: false,
        slideShadows: false
      },
      simulateTouch: false,
      breakpoints: {
        990: {
          direction: 'vertical'
        }
      }
    }

    imageSlider1 = undefined;
    imageSlider2 = undefined;
    contentSlider = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initImageSliders();
      this.initContentSlider();
      this.initArrows();
    }

    initImageSliders() {
      this.imageSlider1 = new Swiper(
        this.querySelector(this.selectors.imageSlider1),
        this.imageSliderOptions
      );

      this.imageSlider2 = new Swiper(
        this.querySelector(this.selectors.imageSlider2),
        this.imageSliderOptions
      );
    }

    initContentSlider() {
      this.contentSlider = new Swiper(
        this.querySelector(this.selectors.contentSlider),
        this.contentSliderOptions
      );
    }

    initArrows() {
      const prevArrow = this.querySelector(this.selectors.prevArrow);
      const nextArrow = this.querySelector(this.selectors.nextArrow);

      prevArrow.addEventListener('click', () => {
        for (const slider of [this.imageSlider1, this.imageSlider2, this.contentSlider]) {
          if (!slider) continue;

          slider.slidePrev();
        }
      });

      nextArrow.addEventListener('click', () => {
        for (const slider of [this.imageSlider1, this.imageSlider2, this.contentSlider]) {
          if (!slider) continue;

          slider.slideNext();
        }
      });
    }
  }
  customElements.define('testimonials-slider', TestimonialsSlider);
}
